import { SessionTimeoutService } from '@alpha-core/platform-ui';
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, finalize } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
    const sessionTimeOutService: SessionTimeoutService = inject(SessionTimeoutService);
    const hideSpinner = req.headers.get('alpha-hide-spinner') === 'true';
    const reqId = window.crypto.randomUUID();

    const requestEvent = new CustomEvent('http-plugin:httprequest', {
        detail: { reqId, hideSpinner },
    });
    window.dispatchEvent(requestEvent);

    const newReq = req.clone({
        withCredentials: true,
        headers: hideSpinner ? req.headers.delete('alpha-hide-spinner') : req.headers,
    });

    return next(newReq).pipe(
        catchError((error: HttpErrorResponse) => {
            if (error.status === 401 && !error.url?.includes('/user-info')) {
                sessionTimeOutService.handleSessionExpiration().catch((error) => {
                    console.error('Error handling session expiration:', error);
                });
            }
            return Promise.reject(error);
        }),
        finalize(() => {
            const responseEvent = new CustomEvent('http-plugin:httpresponse', {
                detail: { reqId },
            });
            window.dispatchEvent(responseEvent);
        }),
    );
};
